import * as React from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import { bind } from '../Utils/Bind';

export interface IPrivateRouteProps extends RouteProps {
    readonly roles?: string[];
    readonly user?: { id: string; roles: string[] };
}

export class PrivateRoute extends React.Component<IPrivateRouteProps> {
    public render() {
        const { component, ...rest } = this.props;
        return <Route {...rest} render={this.tryRender} />;
    }

    @bind
    private tryRender(props: RouteComponentProps<any>): JSX.Element | undefined {
        const Component: any = this.props.component;
        const roles = this.props.roles ?? [];
        const userRoles = this.props.user?.roles ?? [];
        const isAuthenticated = !!this.props.user;
        const hasRoles = roles.length > 0;
        const inRole = roles.filter(r => userRoles.includes(r)).length > 0;
        const portalUserRoles = ['MriAdmin', 'PortalAdmin', 'MriUser', 'PortalUser', 'PortalLiteUser'];
        const isPortalUser = portalUserRoles.filter(r => userRoles.includes(r)).length > 0;
        const internalUrl = (window as any).initialInternalUrl as string;

        if (!isAuthenticated) {
            return (
                <Redirect
                    to={{
                        pathname: '/account/spa-login',
                        state: {
                            returnUrl: window.location.pathname + window.location.search,
                        },
                    }}
                />
            );
        } else if (hasRoles && !inRole) {
            return (
                <>
                    <p>You are unauthorized to view this page. Please contact your account administrator.</p>
                    {!isPortalUser && internalUrl && (
                        <p>
                            Click <a href={internalUrl}>Here</a> to view MRI's internal tools.
                        </p>
                    )}
                </>
            );
        } else {
            return <Component {...props} />;
        }
    }
}
